<template>
  <div>
    <!--
            <ion-icon slot="start" v-if="syncStatus == 0" :icon="cloudOutline" color="success"></ion-icon>
        -->
    <ion-icon
      v-if="syncStatus == 1"
      slot="start"
      :icon="cloudUploadOutline"
      color="primary"
    />
    <ion-icon
      v-if="syncStatus == 2"
      slot="start"
      :icon="cloudDownloadOutline"
      color="primary"
    />
    <ion-icon
      v-if="syncStatus == 3"
      slot="start"
      :icon="cloudOffline"
      color="danger"
      @click="sync"
    />
  </div>
</template>

<script>
import {cloudUploadOutline, cloudOffline, cloudDownloadOutline} from 'ionicons/icons';
import {IonIcon} from '@ionic/vue';

export default {
    components: {
        IonIcon,
    },
    data() {
        return {
            cloudUploadOutline,
            cloudDownloadOutline,
            cloudOffline,
        };
    },
    computed: {
        syncStatus() {
            return this.$store.getters.syncStatus;
        },
    },
    methods: {
        sync() {
            this.$store.dispatch('upsync');
        },
    },
};
</script>

<style scoped>

</style>
